import { css } from "@emotion/css"
import React from "react"

import Image from "@p-ban/common/src/components/html/Image"

import type EstimateValues from "../../../../../types/params"
import getBaseColor from "../../../../service/getBaseColor"

import bottomBlack from "./img/bottom_black.png"
import bottomBlue from "./img/bottom_blue.png"
import bottomGreen from "./img/bottom_green.png"
import bottomMatteBlack from "./img/bottom_matteBlack.png"
import bottomNone from "./img/bottom_none.png"
import bottomOrange from "./img/bottom_orange.png"
import bottomPurple from "./img/bottom_purple.png"
import bottomRed from "./img/bottom_red.png"
import bottomWhite from "./img/bottom_white.png"
import bottomYellow from "./img/bottom_yellow.png"
import topBlack from "./img/top_black.png"
import topBlue from "./img/top_blue.png"
import topGreen from "./img/top_green.png"
import topMatteBlack from "./img/top_matteBlack.png"
import topNone from "./img/top_none.png"
import topOrange from "./img/top_orange.png"
import topPurple from "./img/top_purple.png"
import topRed from "./img/top_red.png"
import topWhite from "./img/top_white.png"
import topYellow from "./img/top_yellow.png"

const topImages = {
  green: topGreen,
  red: topRed,
  blue: topBlue,
  yellow: topYellow,
  white: topWhite,
  black: topBlack,
  matteBlack: topMatteBlack,
  purple: topPurple,
  orange: topOrange,
} as const
const bottomImages = {
  green: bottomGreen,
  red: bottomRed,
  blue: bottomBlue,
  yellow: bottomYellow,
  white: bottomWhite,
  black: bottomBlack,
  matteBlack: bottomMatteBlack,
  purple: bottomPurple,
  orange: bottomOrange,
} as const

type Props = {
  pattern: "both" | "top" | "bottom" | "none"
  values: EstimateValues
  children?: React.ReactNode
}

const ColorPattern = ({ pattern, values, children }: Props) => {
  const color = getBaseColor(values)

  const topImage = pattern === "both" || pattern === "top" ? topImages[color] : topNone
  const bottomImage = pattern === "both" || pattern === "bottom" ? bottomImages[color] : bottomNone

  return (
    <span className={style}>
      <Image src={topImage} alt="" width={30} height={30} />
      <Image src={bottomImage} alt="" width={30} height={30} />
      {children}
    </span>
  )
}

export default ColorPattern

const style = css`
  position: relative;
  width: 30px;
  height: 30px;
  > * {
    position: absolute;
    top: 0;
    left: 0;
  }
`
